<template>
    <div class="component-group"
         :class="{
            active: !!region
         }"
    >
        <form-group :label="$t(`${translationsGroup}.region`)"
                    :errors="errors"
                    :required="true"
                    label-for="region"
                    name="region"
        >
            <select-box :options="getRegions"
                        :value="region"
                        :placeholder="$t(`${placeholdersGroup}.select_option`)"
                        name="region"
                        id="region"
                        @update="onUpdateRegionField"
            />
        </form-group>
        <form-group v-if="!!region && !isSelectedRegionOther && !!getMunicipalities.length"
                    :label="$t(`${translationsGroup}.municipality`)"
                    :required="true"
                    :errors="errors"
                    label-for="municipality"
                    name="municipality"
        >
            <select-box :options="getMunicipalities"
                        :value="municipality"
                        :placeholder="$t(`${placeholdersGroup}.select_option`)"
                        name="municipality"
                        id="municipality"
                        @update="onUpdateRegionField"
            />
        </form-group>
        <form-group v-if="!!municipality && !isSelectedRegionOther && !!getPlaceOfResidence.length"
                    :label="$t(`${translationsGroup}.place_of_residence`)"
                    :required="false"
                    :errors="errors"
                    label-for="residence_place"
                    name="residence_place"
        >
            <select-box :options="getPlaceOfResidence"
                        :value="residencePlace"
                        :placeholder="$t(`${placeholdersGroup}.select_option`)"
                        name="residence_place"
                        id="residence_place"
                        @update="onUpdateRegionField"
            />
        </form-group>
        <form-group v-if="!!isSelectedRegionOther"
                    :label="$t('words.other')"
                    :errors="errors"
                    :required="true"
                    labelFor="otherRegion"
                    name="otherRegion"
        >
            <input :placeholder="$t('placeholders.enter_other_region')"
                   :value="otherRegion"
                   type="text"
                   name="otherRegion"
                   id="otherRegion"
                   class="blood-donors-create-update-input"
                   @input="onUpdateRegionField('otherRegion', $event.target.value)"
            />
        </form-group>
        <form-group v-if="!!isSelectedRegionOther"
                    :label="`${$t('words.city')}/${$t('words.municipality')}`"
                    :errors="errors"
                    :required="true"
                    labelFor="otherRegion"
                    name="otherRegion"
        >
            <input :placeholder="$t('placeholders.enter_municipality')"
                   :value="municipality"
                   type="text"
                   name="municipality"
                   id="municipality"
                   class="blood-donors-create-update-input"
                   @input="onUpdateRegionField('municipality', $event.target.value)"
            />
        </form-group>
    </div>
    <form-group :label="$t(`${translationsGroup}.address`)"
                :required="true"
                :errors="errors"
                label-for="address"
                name="address"
    >
        <input :placeholder="$t(`${placeholdersGroup}.select_address`)"
               :value="address"
               name="address"
               class="blood-donors-create-update-input"
               @input="onUpdateRegionField('address', $event.target.value)"
        />
    </form-group>
</template>

<script>
import FormGroup from '../../../../../../Components/Forms/Holders/FormGroup';
import SelectBox from '../../../../../../Components/Forms/SelectBox/SelectBox';
import Regions from '../../../../../../../Src/Data/regions.json';
import Language from '../../../../../../../Src/Modules/Localization/Language';
import CountrySelect from '../../../../../../Components/Forms/Select/CountrySelect';

export default {
    name: 'RegionComponent',
    emits: [
        'update',
    ],
    components: {
        CountrySelect,
        SelectBox,
        FormGroup
    },
    props: {
        region: {
            type: String,
            default: null
        },
        municipality: {
            type: String,
            default: null
        },
        residencePlace: {
            type: String,
            default: null
        },
        otherRegion: {
            type: String,
            default: null
        },
        address: {
            type: String,
            default: null
        },
        errors: {
            default: null
        },
        translationsGroup: {
            type: String,
            default: 'words'
        },
        placeholdersGroup: {
            type: String,
            default: 'placeholders'
        },
    },
    computed: {
        isSelectedRegionOther() {
            return this.region === this.$t('words.other');
        },
        getAllRegions() {
            return Regions[Language.get()];
        },
        getRegions() {
            return [
                ...Object.keys(this.getAllRegions),
                this.$t('words.other')
            ];
        },
        getMunicipalities() {
            return !!this.region && !this.isSelectedRegionOther && !!this.getAllRegions[this.region]
                ? Object.keys(this.getAllRegions[this.region])
                : [];
        },
        getPlaceOfResidence() {
            return !!this.region && !this.isSelectedRegionOther && !!this.getAllRegions[this.region] && !!this.municipality
                ? this.getAllRegions[this.region][this.municipality]
                : [];
        },
    },
    methods: {
        onUpdateRegionField(name, value) {
            this.$emit('update', name, value);
        },
    },
}
</script>